import styled from 'styled-components'

const StyledLoginPage = styled.div`
  max-width: 1024px;
  position: relative;
  z-index: 100;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  width: 100vw;
  width: calc(var(--vw, 1vw) * 100);
  padding-top: 1rem;
  margin: 0 auto;
  display:flex;
  flex-wrap:wrap;
  justify-content:center;
`

const StyledLoginHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-self: flex-start;
`

const StyledLanguageSwitcher = styled.div`
font-size: 1.5em;
`

const LanguageButton = styled.button`
background-color: transparent;
border: none;
padding: 0.5rem;
font-weight: 300;
color: white;

:hover {
  font-weight: bold;
}
:focus & :active {
  font-weight: bold;
}
`

const StyledLogo = styled.img`
  width: 100%;
  max-width: 10rem;
  height: auto;
  padding: 0.313rem;
`

const StyledLoginForm = styled.form`
  display: grid;
  justify-content: center;
  grid-gap: 1rem;
  width: 100%;
  h2 {
    font-size: 3em;
    font-weight: normal;
    text-align: center;
    padding: 0.5em;
  }
  label {
    display: flex;
  }
  label > div {
    margin-top: 0.5rem;
    color: #fdfdfd;
    background-color: #1e2f60;
    flex: 1;
    padding: 0.55rem;
    text-align: center;
    font-size: 1.5em;
    margin: 0;

  }
  label > input {
    flex: 0;
    border: none;
    color: #1e2f60;
    background-color: #fdfdfd;
    padding: 0.55rem;
    font-size: 1.5em;
    font-weight: 300;
  }
`

const StyledLoginContent = styled.div``

const StyledHeading = styled.h1`
  display:flex;
  flex-direction:column;
  text-align: center;
  font-size: 4em;
  font-weight: 500;
`

const ButtonWrapper = styled.div`
min-width: 70%;
width: 100%;
display: flex;
justify-content:center;

a {
  text-decoration: none;
}
button {
  span {
  color: black;
  }
}

@media (orientation: portrait) {
  button {
    background: #fdfdfd;
  }
}
`

export { StyledHeading, StyledLoginHeader, StyledLanguageSwitcher, StyledLoginForm, StyledLoginPage, StyledLogo, LanguageButton, StyledLoginContent, ButtonWrapper }
